import loadScript from "../../../utils/loadScript";

export default function setUpPayments(
    createMicroformTokenMutation,
    microformState,
    setMicroformState,
    cart,
    setCardNumberData,
    setSecurityCodeData,
    setCardMeta=null,
    basicPayload,
) {
    createMicroformTokenMutation({
        variables: {
            requestData: {
                ...basicPayload
            }
        }
    }).then((data) => {
        const gqlResponse = data.data.createMicroformToken;

        loadScript(gqlResponse.client_library, gqlResponse.client_library_integrity, 'anonymous').then(() => {
            const microformRequestToken = data.data.createMicroformToken.token

            setUpFlex(
                microformRequestToken,
                microformState,
                setMicroformState,
                setCardMeta,
                setCardNumberData,
                setSecurityCodeData
            );
        });
    });
}

function setUpFlex(
    requestToken,
    microformState,
    setMicroformState,
    setCardMeta,
    setCardNumberData,
    setSecurityCodeData
) {
    const flexStyles = {
        'input': {
            'font-size': '1rem',
            'font-family': '"Noto Sans", "Noto Sans Fallback: Arial", arial, sans-serif',
            'color': '#4a4a4a'
        },
        '::placeholder': { 'color': '#d4d4d4' },
        ':focus': { 'color': '#4a4a4a' },
        ':disabled': { 'cursor': 'not-allowed' },
        'valid': { 'color': '#5DC1AB' },
        'invalid': { 'color': '#EF4135' }
    };

    const newFlex = new Flex(requestToken)
    const newMicroform = newFlex.microform('card', {styles: flexStyles})

    const number = newMicroform.createField('number', {placeholder: "Enter card number"})
    number.on('change', data => {
        if (setCardMeta && data.card[0]) setCardMeta(data.card[0]);
        setCardNumberData(data);
    });
    number.load("#number-container");

    const securityCode = newMicroform.createField('securityCode', {placeholder: "Enter security code"})
    securityCode.on('change', data => {
        setSecurityCodeData(data);
    });
    securityCode.load("#securityCode-container")

    setMicroformState(microformState => ({...microformState, microform: newMicroform}));
}
